import { render } from "./ViewTeacherDetails.vue?vue&type=template&id=089a2130&scoped=true"
import script from "./ViewTeacherDetails.vue?vue&type=script&lang=js"
export * from "./ViewTeacherDetails.vue?vue&type=script&lang=js"

import "./ViewTeacherDetails.vue?vue&type=style&index=0&id=089a2130&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089a2130"]])

export default __exports__